import {createI18n} from "vue-i18n";
import enUS from "./locales/en-US";
import ptBR from "./locales/pt-BR";
import thTH from "./locales/th-TH";
import idID from "./locales/id-ID";
import jaJP from "./locales/ja-JP";
import koKR from "./locales/ko-KR";
import viVN from "./locales/vi-VN";
import filPH from "./locales/fil-PH";
import urPK from "./locales/ur-PK";
import msMY from "./locales/ms-MY";
import esMX from "./locales/es-MX";
import hiIN from "./locales/hi-IN";
import esES from "./locales/es-ES";
import {Local, STORAGE_KEYS} from 'utils/storage';

// 获取当前语言，如果没有则使用浏览器语言或默认为中文
const getLocale = () => {
    return Local.get(STORAGE_KEYS.LOCALE) || "en-US";
};

// ========== 自动扫描页面和组件的 i18n 目录 ==========
// 自动扫描所有页面和组件的 i18n 目录下的语言包文件
const pages = import.meta.glob('./../**/**/i18n/*.js', { eager: true });

// 按语言分类，初始化时包含框架级语言包
const itemize = {
    'en-US': [enUS],
    'pt-BR': [ptBR],
    'th-TH': [thTH],
    'id-ID': [idID],
    'ja-JP': [jaJP],
    'ko-KR': [koKR],
    'vi-VN': [viVN],
    'fil-PH': [filPH],
    'ur-PK': [urPK],
    'ms-MY': [msMY],
    'es-MX': [esMX],
    'hi-IN': [hiIN],
    'es-ES': [esES]
};

// 处理自动扫描的文件
for (const path in pages) {
    const match = path.match(/\/([^/]+)\.js$/);
    if (match) {
        const key = match[1]; // 提取文件名
        if (itemize[key]) {
            itemize[key].push(pages[path].default);
        } else {
            console.warn('⚠️ 未知语言代码:', key, '在', path);
        }
    }
}

// 合并同语言的所有对象
function mergeArrObj(list, key) {
    let obj = {};
    list[key].forEach((i) => {
        obj = Object.assign({}, obj, i);
    });
    return obj;
}

// 生成最终的 messages 对象
const messages = {};
for (const key in itemize) {
    messages[key] = mergeArrObj(itemize, key);
}

// ========== 自动扫描结束 ==========

// 创建 i18n 实例
const i18n = createI18n({
    legacy: false, // 使用传统模式
    locale: getLocale(), // 默认语言
    fallbackLocale: "en-US", // 备用语言
    globalInjection: true, // 全局注入 $t 函数
    messages: messages,
});

export default i18n;
